import React, { useState, useEffect } from 'react';
import { Search } from 'lucide-react';

const styles = {
  primaryColor: '#F76707',
  secondaryColor: '#0A6EBD',
};

/**
 * Composant de recherche de réclamation par numéro de suivi
 * Ce composant est utilisé sur la page principale de suivi quand aucune réclamation n'est encore chargée
 */
const SearchTracking = ({ onSearch, showError, initialValue = '' }) => {
  // État local pour le numéro de suivi
  const [trackingNumber, setTrackingNumber] = useState(initialValue);

  // Mettre à jour l'état si initialValue change
  useEffect(() => {
    if (initialValue) {
      setTrackingNumber(initialValue);
    }
  }, [initialValue]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (trackingNumber.trim()) {
      onSearch(trackingNumber);
    }
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <h1 className="text-center mb-4" style={{ color: styles.secondaryColor }}>
            Suivi de votre réclamation
          </h1>
          <form onSubmit={handleSubmit}>
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control"
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
                placeholder="Numéro de suivi (ex: REC123)"
                aria-label="Numéro de suivi"
                aria-describedby="search-button"
              />
              <button
                id="search-button"
                className="btn"
                type="submit"
                style={{ backgroundColor: styles.primaryColor, color: 'white' }}
              >
                <Search className="w-5 h-5" />
              </button>
            </div>
          </form>
          {showError && (
            <div className="alert alert-danger" role="alert">
              Réclamation introuvable. Veuillez vérifier le numéro de suivi.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchTracking;